import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'

import { storeAccessToken } from '../../../services/data/accessToken'

import { setError, removeError } from '../../../modules/errors/actions/creators'
import { setDevice } from '../../../modules/device/actions/creators'
import { setStep } from '../../../modules/registration/actions/creators'
import { addCard } from '../../../modules/card/actions/creators'

import {
  doHandleOnLoad,
  doDeleteCard,
  doContinueAddCard,
  doGetApiKey,
  doLoadCardList,
} from '../../../controllers/Registration'
import { doGetAllAds } from '../../../controllers/BannerAds'

import MainView from '../components/MainView/MainView'

const saveAccessToken = accessToken => {
  storeAccessToken(accessToken)
  return {
    type: '',
    payload: {},
  }
}

const mapStateToProps = reduxState => {
  const {
    auth,
    errors,
    registration,
    profile,
    device: deviceModule,
  } = reduxState
  const { browser } = deviceModule
  const { accessToken, redirectAfterAuth } = auth
  const { primaryInfo } = profile
  const { step } = registration
  const { errorList } = errors

  return {
    accessToken,
    primaryInfo,
    redirectAfterAuth,
    step,
    browser,
    doHandleOnLoad,
    doDeleteCard,
    doContinueAddCard,
    doGetApiKey,
    doGetAllAds,
    doLoadCardList,
    errorList,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setDevice,
      setStep,
      addCard,
      push,
      saveAccessToken,
      setError,
      removeError,
    },
    dispatch,
  )

const ConnectedMainView = connect(mapStateToProps, mapDispatchToProps)(MainView)

export default ConnectedMainView
